import script from "./KBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./KBtn.vue?vue&type=script&setup=true&lang=ts"

import "./KBtn.vue?vue&type=style&index=0&id=01c0cdd5&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-01c0cdd5"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
